__turbopack_context__.v({
  "cardName": "comboResult-module-scss-module__Z6bhxG__cardName",
  "comboResult": "comboResult-module-scss-module__Z6bhxG__comboResult",
  "comboResultSection": "comboResult-module-scss-module__Z6bhxG__comboResultSection",
  "prerequisites": "comboResult-module-scss-module__Z6bhxG__prerequisites",
  "variantBanner": "comboResult-module-scss-module__Z6bhxG__variantBanner",
});
